var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.7 15.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_1852",
    "data-name": "\\u77E9\\u5F62 1852",
    x: -8.12,
    y: -1329.92,
    width: 730,
    height: 361,
    rx: 19,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 53.22,
    x2: -13.11,
    y2: -690.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 45.19,
    x2: -13.11,
    y2: -698.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 37.15,
    x2: -13.11,
    y2: -706.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 29.12,
    x2: -13.11,
    y2: -714.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 21.07,
    x2: -13.11,
    y2: -722.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 13.03,
    x2: -13.11,
    y2: -730.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 730.38,
    y1: 5,
    x2: -13.11,
    y2: -738.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.61px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_6",
    "data-name": "\\u56FE\\u5C42 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.85,15.7A7.85,7.85,0,1,1,15.7,7.85,7.86,7.86,0,0,1,7.85,15.7ZM7.85,2A5.85,5.85,0,1,0,13.7,7.85,5.85,5.85,0,0,0,7.85,2Z",
    style: {
      fill: "#514b45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,10.25a1,1,0,0,1-.59-.19l-1.9-1.4a1,1,0,0,1-.41-.81V3.53a1,1,0,1,1,2,0V7.35l1.5,1.1a1,1,0,0,1-.6,1.8Z",
    style: {
      fill: "#514b45"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSand);
export default __webpack_public_path__ + "static/media/sand.d694c07f.svg";
export { ForwardRef as ReactComponent };